import { EtapeId, EtatOnboarding, OnboardingLocal } from './types';

export interface Etape {
  id: EtapeId;
  titre: string;
  sousTitre: string;
  terminee: boolean;
  /** Libellé du bouton, affiché uniquement pour l'étape courante. */
  libelleAction: string;
}

/**
 * Dérivation PURE des quatre étapes. Testable sans React.
 *
 * Règle non négociable : « terminée » se lit sur l'ÉTAT SERVEUR (nbVoyageurs,
 * nbDemandes) pour les étapes 3 et 4. Seule l'étape 2 s'appuie sur le local,
 * parce que « avoir regardé une destination » n'existe pas côté serveur — et
 * qu'une étape 2 décochée à tort ne fait perdre à personne un dossier réel.
 */
export const derivarEtapes = (etat: EtatOnboarding, local: OnboardingLocal): Etape[] => {
  const visa = local.visaChoisi;
  const resumeVisa = visa ? `${visa.paysLibelle} · ${visa.titre}` : null;

  return [
    {
      id: 'compte',
      titre: 'Votre compte est créé',
      sousTitre: '',
      terminee: true,
      libelleAction: '',
    },
    {
      id: 'destination',
      titre: 'Choisissez votre destination',
      sousTitre: resumeVisa ?? 'Comparez les visas et leurs tarifs, sans rien saisir',
      terminee: visa !== null,
      libelleAction: 'Voir les destinations',
    },
    {
      id: 'voyageur',
      titre: 'Préparez le profil du voyageur',
      sousTitre:
        etat.nbVoyageurs > 0
          ? 'Profil enregistré'
          : "Passeport et photo d'identité nécessaires",
      terminee: etat.nbVoyageurs > 0,
      libelleAction: 'Créer le profil',
    },
    {
      id: 'demande',
      titre: 'Remplissez votre demande',
      sousTitre: resumeVisa ?? "Choisissez d'abord une destination",
      terminee: etat.nbDemandes > 0,
      libelleAction: visa ? 'Continuer ma demande' : 'Voir les destinations',
    },
  ];
};

/** Index de la première étape non terminée, ou -1 si tout est fait. */
export const indexEtapeCourante = (etapes: Etape[]): number =>
  etapes.findIndex((e) => !e.terminee);
